import { render, staticRenderFns } from "./PasswordSendEmail.vue?vue&type=template&id=32012c9b&"
import script from "./PasswordSendEmail.vue?vue&type=script&lang=js&"
export * from "./PasswordSendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports